import { useState, useEffect } from 'react';
import { supabaseFetch } from '../utils/supabaseHelper';
import './HeroBanner.css';

// Default slides - shown immediately
const defaultSlides = [
  { id: 1, image_url: '/images/slides/7.jpeg', alt_text: 'Financial Services' },
  { id: 2, image_url: '/images/slides/8.jpeg', alt_text: 'Insurance Plans' },
  { id: 3, image_url: '/images/slides/9.jpeg', alt_text: 'Investment Options' },
  { id: 4, image_url: '/images/slides/10.jpeg', alt_text: 'Savings Plans' }
];

const HeroSlide = ({ slide }) => {
  return (
    <div className="banner-slide">
      <img
        src={slide.image_url}
        alt={slide.alt_text}
        className="slide-image loaded"
        draggable="false"
        onDragStart={(e) => e.preventDefault()}
      />
    </div>
  );
};

const HeroBanner = () => {
  const [selectedProduct, setSelectedProduct] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState(defaultSlides);

  // Fetch slides from Supabase (optional - will use defaults if fetch fails)
  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const data = await supabaseFetch('hero_slides?select=*&order=sequence_order.asc');

        if (data && data.length > 0) {
          setSlides(data);
        }
      } catch (err) {
        // Keep using default slides
      }
    };

    fetchSlides();
  }, []);

  // Auto-scroll slides
  useEffect(() => {
    if (slides.length === 0) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (agreed) {
      setIsSubmitting(true);
      setSubmitStatus(null);

      const formData = {
        access_key: 'c8a12abf-15ee-4ce0-a237-0a0b22265ae0',
        contact_name: name,
        contact_phone: phone,
        interested_product: selectedProduct,
        subject: `${selectedProduct.charAt(0).toUpperCase() + selectedProduct.slice(1)} Enquiry`,
        from_name: 'InstaCredMoney Website'
      };

      try {
        const response = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (result.success) {
          setSubmitStatus('success');
          // Reset form
          setName('');
          setPhone('');
          setSelectedProduct('');
          setAgreed(false);
          // Hide success message after 5 seconds
          setTimeout(() => setSubmitStatus(null), 5000);
        } else {
          setSubmitStatus('error');
          console.error('Form submission error:', result);
        }
      } catch (error) {
        setSubmitStatus('error');
        console.error('Form submission exception:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // Swipe/Drag Logic
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  // Minimum swipe distance (in px) required for swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
    setIsDragging(true);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    setIsDragging(false);
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }
    if (isRightSwipe) {
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    }
  };

  // Mouse Events for Desktop "Swipe"
  const onMouseDown = (e) => {
    setTouchEnd(null);
    setTouchStart(e.clientX);
    setIsDragging(true);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    setTouchEnd(e.clientX);
  };

  const onMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false);

    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }
    if (isRightSwipe) {
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    }

    // Reset
    setTouchStart(null);
    setTouchEnd(null);
  };

  const onMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      setTouchStart(null);
      setTouchEnd(null);
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-banner">


            <div
              className="slider-container"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseLeave}
              style={{ cursor: isDragging ? 'grabbing' : 'grab', userSelect: 'none' }}
            >
              <div
                className="slides-wrapper"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {slides.map((slide) => (
                  <HeroSlide
                    key={slide.id}
                    slide={slide}
                  />
                ))}
              </div>
            </div>

            <div className="carousel-dots">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                ></span>
              ))}
            </div>
          </div>

          <div className="sidebar-form">
            <h3 className="form-title">Let's Find What You Need</h3>

            {submitStatus === 'success' && (
              <div className="success-modal-overlay">
                <div className="success-content">
                  <div className="success-icon-wrapper">
                    <div className="checkmark"></div>
                  </div>
                  <h4 className="success-title">Enquiry Sent!</h4>
                  <p className="success-message-text">We have received your details and will get back to you shortly.</p>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="alert error-message" style={{ color: 'red', marginBottom: '15px', fontWeight: 'bold' }}>
                Something went wrong. Please try again later.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>PRODUCT</label>
                <select
                  value={selectedProduct}
                  onChange={(e) => setSelectedProduct(e.target.value)}
                  className="form-control"
                >
                  <option value="">Select Product</option>
                  <option value="loans">Loans</option>
                  <option value="insurance">Insurance</option>
                </select>
              </div>

              <div className="form-group">
                <label>YOUR NAME</label>
                <input
                  type="text"
                  placeholder="Enter Your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>PHONE NUMBER</label>
                <div className="phone-input-group">
                  <span className="country-code">+91</span>
                  <input
                    type="tel"
                    placeholder="Enter Your Phone Number"
                    value={phone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      if (value.length <= 10) {
                        setPhone(value);
                      }
                    }}
                    className="form-control hero-phone-input"
                  />
                </div>
              </div>

              <div className="form-checkbox">
                <input
                  type="checkbox"
                  id="terms"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
                <label htmlFor="terms" className="checkbox-label">
                  I agree to the{' '}
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Terms and Conditions
                  </a>
                </label>
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={!selectedProduct || !name || !phone || !agreed || isSubmitting}
              >
                {isSubmitting ? 'SENDING...' : 'SEND ENQUIRY'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
